import { render, staticRenderFns } from "./PelletizingMaterialCostList.vue?vue&type=template&id=62cb995a&"
import script from "./PelletizingMaterialCostList.vue?vue&type=script&lang=js&"
export * from "./PelletizingMaterialCostList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports